import React, { Component } from 'react'
import _ from 'lodash'
import Tray from '~/modules/Tray/Video'
import Overlay from '~/components/Overlay'
import share from '~/tools/share'
import { getUser } from '~/redux/user/helpers'
import { fetchModels } from '~/redux/models/helpers'
import { getTransactionInfo } from '~/redux/uservideo/helpers'
import './style.scss'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

class Bundle extends Component {
  state = {
    bundle: _.get(this.props, 'data.contentData[0].gist'),
    list: _.get(this.props, 'data.contentData[0].gist.bundleList', []),
    trailer: _.get(this.props, 'data.contentData[0].contentDetails.trailers[0]'),
    isPurchased: false,
    warning: false,
    orientation: 'portrait'
  }

  async componentDidMount() {
    const bundlePricing = this.state.bundle.bundlePricing
    if (!bundlePricing.purchase) {
      this.setState({ 
        isPurchased: true, 
        message: 'This content is free.' 
      })
    } else {
      this.getBundle()
    }
    this.setThumbnailType()
    this.setState({ model: await fetchModels() })
  }

  getBundle() {
    getUser((user) => {
      if (user) {
        if (user.isSubscribed) {
          this.setState({ isPurchased: true, message: 'You have access to this content.' })
        } else {
          getTransactionInfo(user.userId, true).then(res => {
            const bundleList = this.state.list
            const ids = res.data.records.map(d => d.contentResponse.gist.id)
            const filtered = bundleList.filter(i => !ids.includes(i.id))
            if (filtered.length === 0) {
              this.setState({ isPurchased: true, message: 'You\'ve purchased this bundle.' })
            } else if (filtered.length !== bundleList.length && filtered.length > 0) {
              this.setState({ isPurchased: false, warning: 'You have already purchased individual videos within this bundle.' })
            }
          })
        }
      }
    })
  }
  
  setThumbnailType = () => {
    const { bundle: { imageGist } } = this.state
    this.setState({ orientation: imageGist._3x4 ? 'portrait' : 'landscape' })
  }

  playFirstVideo = () => {
    window.location = this.state.list[0].gist.permalink 
  }

  share = (platform, title) => {
    share[platform](window.location.href, title)
  }


	render() {
    const { bundle, list, trailer, isPurchased, orientation, warning, message } = this.state 
    const model = this.state.model
    const ids = _.reduce(list, (arr, e) => {
      arr.push(e.id)
      return arr
    }, [])
    const content = { 
      gist: {
        ...bundle,
        id: { content: bundle.id, items: ids }
      },
      pricing: {
        ...bundle.bundlePricing
      }
    }

		return (
      <div className="bundle-detail">
        <div className="header">
          <div className="video-module-wrapper">
            <div className="header-info">
              <h1 itemProp="name" className="header-title">{bundle.title}</h1>
              <span className="header-details">
                <span>{`${list.length} videos`}</span>
              </span>
            </div>
          </div>
        </div>
        <div className="main-content">
          <div className="top-content">
            <div className="bundle-cover">
              <img src={bundle.imageGist._16x9} alt={bundle.title} /> 
            </div>
            { !isPurchased ?
              <div className='overlay-wrapper'>
                <Overlay 
                  content={content} 
                  watchNow={this.playFirstVideo} 
                  model={model} 
                  warning={warning}
                  bundleOverlay={true}
                />
              </div>
             : <div className="overlay-video-container purchased">
                <div className="overlay-video">
                  <div className="overlay-title">
                    <span>{message}</span>
                  </div>
                </div>
                <div className="overlay-body">
                  <div className="overlay-button site-background-color">
                    <button onClick={this.playFirstVideo}>Watch now</button>
                  </div>
                </div>
              </div> }
          </div>
          <div className="bottom-content">
            <p className="bundle-description">{bundle.description}</p> 
            { trailer && <div className="bundle-trailer">
              <a href={trailer.permalink}>
                <div className="trailer">
                  <img src={trailer.videoImageUrl} alt={bundle.title} />
                  <i className="ion-ios-play site-color"></i>
                </div>
              </a>
              <div className="sharing-buttons">
                <i className="ion-social-twitter" onClick={() => this.share('twitter', 'Bundle page')} />
                <i className="ion-social-facebook" onClick={() => this.share('facebook')} />
                <i className="ion-ios-email" onClick={() => this.share('email')} />
              </div>
            </div> }
          </div>
        </div>
        <Tray
          layout={{
            settings: { 
              infoHover: true, 
              thumbnailType: orientation, 
              loop: list.length > 6,
              columns: {
                desktop: 6,
                mobile: 3,
                ott: 6,
                tablet: 4
              } 
            }
          }}
          data={{
            contentData: list,
            title: 'Inside the bundle',
          }} 
        />
      </div>
		)
	}
}


connect(
	Bundle,
	(state) => ({ user: state.user }),
	userStore
)

export default Bundle
